<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-10-23 18:25:04
 * @FilePath: 
 * @Description: 乐园报表
-->
<template>
  <div class="c-p-t-1 full_page_grey">
    <date-tab-com
      ref="dateTabRef"
      @change="handleChangeDateType"
      @changeDate="handleChangeDateData"
    ></date-tab-com>
    <div class="ticheng_title_con">
      <p class="ticheng_left_con">实时数据查询</p>
    </div>
    <div class="total_count_con state_box_con">
      <p class="c-ft-28">总营业额</p>
      <p class="c-ft-50 c-m-tb-48 state_blue_color">
        {{ turnoverObj.turnoverTotal }}
      </p>
      <div class="f-ar w-100% c-ft-24">
        <div class="turnover_con">
          <p>有效营业额收入</p>
          <p class="turnover_money state_blue_color">
            {{ turnoverObj.validTurnover }}元
          </p>
        </div>
        <div class="turnover_con">
          <p>非营业额收入</p>
          <p class="turnover_money state_blue_color">
            {{ turnoverObj.unTurnOver }}元
          </p>
        </div>
      </div>
    </div>
    <div class="ticheng_title_con">
      <p class="ticheng_left_con">营业概况</p>
    </div>
    <div class="state_box_con">
      <div class="c-f state_table_title">
        <span class="f-1">名称</span>
        <span class="f-1">合计</span>
        <span class="f-1">与上期同比</span>
      </div>
      <div class="c-flex c-p-lr-32">
        <div class="f-1 state_table_body">
          <p class="c-grey-6">营业额</p>
          <p class="c-grey-6">进店人数</p>
          <p class="c-grey-6">游玩组数</p>
          <p class="c-grey-6">人均消费</p>
          <p class="c-grey-6">门票收入</p>
        </div>
        <div class="f-1 state_table_body">
          <p>{{ visitorsInfo.turnoverRatio }}元</p>
          <p>{{ visitorsInfo.turnoverRatio }}人</p>
          <p>{{ visitorsInfo.turnoverRatio }}组</p>
          <p>{{ visitorsInfo.turnoverRatio }}元</p>
          <p>{{ visitorsInfo.turnoverRatio }}元</p>
        </div>
        <div class="f-1 state_table_body visitor_ratio_col">
          <p
            :class="
              visitorsInfo.turnoverRatio > 0 ? 'red_radio' : 'green_radio'
            "
          >
            <span>{{ visitorsInfo.turnoverRatio }}</span
            ><span>元</span>
          </p>
          <p
            :class="
              visitorsInfo.turnoverRatio > 0 ? 'red_radio' : 'green_radio'
            "
          >
            <span>{{ visitorsInfo.turnoverRatio }}</span
            ><span>人</span>
          </p>
          <p
            :class="
              visitorsInfo.turnoverRatio > 0 ? 'red_radio' : 'green_radio'
            "
          >
            <span>{{ visitorsInfo.turnoverRatio }}</span
            ><span>组</span>
          </p>
          <p
            :class="
              visitorsInfo.turnoverRatio > 0 ? 'red_radio' : 'green_radio'
            "
          >
            <span>{{ visitorsInfo.turnoverRatio }}</span
            ><span>元</span>
          </p>
          <p
            :class="
              visitorsInfo.turnoverRatio > 0 ? 'red_radio' : 'green_radio'
            "
          >
            <span>{{ visitorsInfo.turnoverRatio }}</span
            ><span>元</span>
          </p>
        </div>
      </div>
    </div>
    <div class="ticheng_title_con">
      <p class="ticheng_left_con">营业额对应付款方式统计</p>
    </div>
    <div class="state_box_con">
      <div class="c-f-bt state_table_title">
        <span class="">支付方式</span>
        <span class="">金额/元</span>
      </div>
      <div
        class="c-f-bt c-p-lr-32 c-m-tb-24"
        v-for="(item, index) in payMethodsList"
        :key="index"
      >
        <div class="state_table_body">
          {{ item.Name }}
        </div>
        <div class="state_table_body">
          {{ item.Money }}
        </div>
      </div>
      <div class="c-f-bt c-p-lr-32 c-m-tb-24 c-p-b-24">
        <div class="state_table_body">合计</div>
        <div class="state_table_body">
          {{ totalMoney }}
        </div>
      </div>
    </div>
    <div class="ticheng_title_con">
      <p class="ticheng_left_con">OTA订单分类统计</p>
    </div>
    <div class="state_box_con"></div>
    <div class="ticheng_title_con">
      <p class="ticheng_left_con">结账人数统计</p>
    </div>
    <div class="state_box_con"></div>
  </div>
</template>

<script>
import DateTabCom from "./comps/dateTabCom.vue";
import { getSinglePerformance } from "@/api/performance";
export default {
  name: "SinglePerformance",
  props: {},
  data() {
    return {
      singleTotalBonus: "--",
      turnoverObj: {},
      visitorsInfo: {
        turnoverRatio: 1224,
      },
      payMethodsList: [
        { Name: "营业额收入", Money: "20866.95" },
        { Name: "微信扫码", Money: "1041.00" },
        { Name: "现金", Money: "531.00" },
        { Name: "POS机", Money: "529.00" },
        { Name: "支付宝扫码", Money: "12318.15" },
        { Name: "纸质门票券", Money: "177.00" },
        { Name: "快手限时47", Money: "141.00" },
        { Name: "美团套票98", Money: "98.00" },
        { Name: "会员卡", Money: "2240.00" },
      ],
      productObj: {},
      goodsObj: {},
      memberCardObj: {},
    };
  },
  components: { DateTabCom },
  created() {},
  computed: {
    totalMoney() {
      let totalNum = 0;
      this.payMethodsList.forEach((element) => {
        totalNum += element.Money - 0;
      });
      return totalNum;
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.dateType = this.$refs.dateTabRef.nowDateType;
      this.handleGetSinglePerformance();
    });
  },
  methods: {
    handleChangeDateType(type) {
      this.dateType = type;
      if (this.dateType !== 4) {
        this.handleGetSinglePerformance();
      }
    },
    handleChangeDateData(dateArr) {
      this.startDate = dateArr[0];
      this.endDate = dateArr[1];
      this.handleGetSinglePerformance();
    },
    handleGetSinglePerformance() {
      // const queryData = {
      //   TimeType: this.dateType,
      //   VpnId: this.$store.state.vpnId,
      // };
      // if (this.dateType == 4) {
      //   queryData.BeginTime = this.startDate;
      //   queryData.EndTime = this.endDate;
      // }
      // getSinglePerformance(queryData).then((res) => {
      //   this.singleTotalBonus = res.TotalCommission;
      //   this.productObj = res.ProductTotal;
      //   this.goodsObj = res.GoodsTotal;
      //   this.memberCardObj = res.MemberCardTotal;
      this.turnoverObj = {
        turnoverTotal: 2512451,
        validTurnover: 35412,
        unTurnOver: 3214,
      };
      // });
    },
    handleToTichengPage(url) {
      this.$router.push({
        name: url,
      });
    },
  },
};
</script>
<style scoped lang="scss">
.state_blue_color {
  color: #5ccdff;
}
.total_count_con {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 58px 0 56px;
  .turnover_con {
    display: flex;
    .turnover_money {
      margin-left: 7px;
    }
  }
}
.state_box_con {
  background: #ffffff;
  box-shadow: 0px 10px 17px 0px rgba(255, 255, 255, 0.56);
  border-radius: 20px;
  margin: 0 32px;
}
.ticheng_title_con {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 32px;
  // background: #fff;
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin: 32px 0 24px;

  .ticheng_left_con {
    padding-left: 20px;
    position: relative;
  }
}
.state_table_title {
  padding: 25px 32px;
  font-weight: bold;
  color: #333;
  border-bottom: 1px solid #ebedf0;
  font-size: 24px;
}
.state_table_body {
  color: #333;
  font-size: 24px;
  p {
    margin: 13px 0;
    height: 48px;
    line-height: 48px;
  }
}
.visitor_ratio_col {
  p {
    width: 100%;
    border-radius: 4px;
    padding: 0 8px;
    color: #fff;
    display: flex;
    justify-content: space-between;
    &.red_radio {
      background: #fe2207;
    }
    &.green_radio {
      background: #3ae340;
    }
  }
}
</style>
